import { InjectionToken, Type } from '@angular/core';

export const CAPTURUM_BUILDERS_BASE_URL = new InjectionToken<Record<string, Type<string>>>('Capturum builder base URL');
